import { IOSFromStrategyIcon } from '@/svgs'
import React from 'react'

function IosFromStrategy() {
   return (
      <section id="development-guide-section" className="cs-bg-theme-color-2">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               From Idea to Execution:
               <br />
               Our Process of iOS App Development
            </h2>

            <p className="section_desc">
               With 12+ years of iOS app development expertise, we develop
               secure, high-performance, and scalable mobile apps to meet the
               needs of your business. Our professional team works with you in
               building a strategic plan for deployment and long-term success.
               Empower your users and drive business success with our iOS
               solutions. Optimize user experience, app performance, and stay
               competitive. Let's build excellence!
            </p>

            <IOSFromStrategyIcon />
         </div>
      </section>
   )
}

export default IosFromStrategy
